let requestHost = () => {};
let hostRequested = false;
let resolveHostReady;
const hostReady = new Promise((resolve) => { resolveHostReady = resolve; });
let sonnerModule;

export function registerToastHost(callback) {
  requestHost = callback;
  if (hostRequested) requestHost();
  return () => { requestHost = () => {}; };
}

export function markToastHostReady() {
  resolveHostReady();
}

function loadToast() {
  hostRequested = true;
  requestHost();
  if (!sonnerModule) sonnerModule = import("sonner");
  return Promise.all([hostReady, sonnerModule]).then(([, module]) => module.toast);
}

const callToast = (method) => (...args) => loadToast().then((toast) => toast[method](...args));

export const toast = {
  success: callToast("success"),
  error: callToast("error"),
  message: callToast("message"),
  warning: callToast("warning"),
  info: callToast("info"),
  dismiss: callToast("dismiss"),
};